import { useContext } from 'react'

import {
  Button, Form, ModalContext, SelectBox, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useSelectOrderItemLiftoverModal from './hooks/useSelectOrderItemLiftoverModal'

const MODAL_KEY = 'SelectOrderItemLiftoverModal'

type ModalCallbacks = {
  closeModal: () => void,
  createEntityName: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  requestOptions?: object,
  showModal: boolean,
}

const SelectOrderItemLiftoverModal = (props: ModalProps) => {
  const { callbacks, requestOptions, showModal } = props
  // @ts-expect-error TS2339
  const { closeModal, selectLiftover } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { callbacks: payloadCallbacks, orderItemId } = modalPayload
  const { createLiftoverOrder: createFn } = payloadCallbacks || {}

  const selectLiftoverPayload = useSelectOrderItemLiftoverModal({ orderItemId })
  const {
    callbacks: {
      buildLiftover,
      selectEditionId,
      selectPublicationId,
    },
    creating,
    filteredEditions,
    filteredPublications,
    saveEnabled,
    selectedEditionId,
    selectedPublicationId,
  } = selectLiftoverPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Select" titleSecondLine="Liftover" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Select Publication">
            <SelectBox
              // @ts-expect-error TS7006
              callbacks={{ selectItem: item => selectPublicationId(item.key) }}
              // @ts-expect-error TS2322
              items={filteredPublications}
              selectedItemKey={selectedPublicationId}
              style={{ zIndex: 10 }}
            />
          </Form.Field>

          {!!selectedPublicationId && (
            <Form.Field label="Select Edition" marginTop="large">
              <SelectBox
                // @ts-expect-error TS7006
                callbacks={{ selectItem: item => selectEditionId(item.key) }}
                // @ts-expect-error TS2322
                items={filteredEditions}
                selectedItemKey={selectedEditionId}
                style={{ zIndex: 9 }}
              />
            </Form.Field>
          )}
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => selectLiftover({
            callbacks: {
              action: () => createFn({
                liftover: buildLiftover(),
                entityOptions: requestOptions,
              }),
              afterAction: closeModal,
            },
            toastText: 'Liftover Added',
          })}
          size="large"
        >
          Select Liftover
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SelectOrderItemLiftoverModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
